module.exports = __webpack_public_path__ + "img/income.3f063a64.svg";